var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LIST"},_vm._l((_vm.services),function(service){return _c('service-card',{key:service.id,attrs:{"service":service}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }